interface CheckboxDisabledParams {
  districtScreeningSetup?: boolean;
  selectedWindow?: {
    screeningWindowType: string | null;
  };
  isCurrentPeriod: boolean;
  isCurrentOutOfDistrictPeriod: boolean;
  previousDistrictWindow: boolean;
}

export const isCheckboxDisabled = ({
  districtScreeningSetup,
  selectedWindow,
  isCurrentPeriod,
  isCurrentOutOfDistrictPeriod,
  previousDistrictWindow
}: CheckboxDisabledParams): boolean => {
  if (districtScreeningSetup) {
    if (selectedWindow?.screeningWindowType === 'DistrictAssignment') {
      return !(isCurrentPeriod || previousDistrictWindow);
    }
    if (selectedWindow?.screeningWindowType === 'Period') {
      return !isCurrentOutOfDistrictPeriod;
    }
    return true;
  } else {
    return !isCurrentOutOfDistrictPeriod;
  }
};